import script from "./CardMonthComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CardMonthComponent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__